import { render, staticRenderFns } from "./topicForm.vue?vue&type=template&id=f0e6c9ae"
import script from "./topicForm.vue?vue&type=script&lang=js"
export * from "./topicForm.vue?vue&type=script&lang=js"
import style0 from "./topicForm.vue?vue&type=style&index=0&id=f0e6c9ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports